import * as Yup from 'yup';

interface DebtorPortalNote extends Yup.MixedSchema {
	note: string;
}

export default () => {
	return Yup.object<DebtorPortalNote>().shape({
		note: Yup.string().required(
			'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD'
		),
	});
};
